/** 批量查询条数上限 */
export const BATCH_QUERY_LIMIT = 500;

/** 批量：逗号 / 分号 / 换行分隔（不按空格拆，避免品牌名被切断） */
export function parseBatchTokens(text) {
  return String(text || '')
    .split(/[,，;；\n\r]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

/** 写入单行输入框时用逗号连接 */
export function joinBatchTokens(tokens) {
  return (Array.isArray(tokens) ? tokens : [])
    .map((s) => String(s || '').trim())
    .filter(Boolean)
    .join(',');
}
